import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

// Fetch all banners
export const getBanners = async () => {
  try {
    const response = await api.get(`${API_URL}/banners`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
  }
};

// Add a new banner
export const addBanner = async (banner) => {
  try {
    const response = await api.post(`${API_URL}/banners`, banner,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); 
  }
};

// Update a banner
export const updateBanner = async (id, banner) => {
  try {
    const response = await api.put(`${API_URL}/banners/${id}`, banner,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); 
  }
};


// Update an astrologer status
export const updateBannerStatus = async (id, updateStatusObj) => {
  try {
    const response = await api.put(`${API_URL}/banners/status/${id}`, updateStatusObj);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); 
  }
};

// Delete a banner
export const deleteBanner = async (id) => {
  try {
    const response = await api.delete(`${API_URL}/banners/${id}`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); 
  }
};


export const getPujaList = async () => {
  try {
    const response = await api.get(`${API_URL}/puja/list`);
    return response.data;
  }
  catch (err) {
    handleUnauthorizedOrForbidden(err);
  }
}
